import React, { useState } from 'react'
import axios from 'axios'
import { Oval } from 'react-loader-spinner'
import { Transition } from '@headlessui/react'
import { BsToggleOff, BsToggleOn } from 'react-icons/bs'

// K
import Subtitle from '../../components/Subtitle'
import Title from '../../components/Title'
// Store
import { Context } from '../../store/Store'
import * as ACTIONS from '../../store/actions/actions'

var _ = require('lodash')

export function PlanificationBilans() {
  const { app, dispatch } = React.useContext(Context)
  const [loading, setLoading] = React.useState(true)
  const [cat, setCat] = useState(null)

  React.useEffect(() => {
    if (app.planification.bilans) {
      let catList = []
      app.planification.bilans.forEach((bilan, i) => {
        catList.push({ catname: bilan.title, show: false })
      })
      setCat(catList)
      setLoading(false)
    }
  }, [app.planification.bilans])

  React.useEffect(() => {
    if (!app.planification.bilans) {
      axios
        .get(`${process.env.REACT_APP_APOLLO_URL || 'https://extranet.biobreizh.org'}/wp-json/bb/v1/planification_bilans`)
        .then(function (response) {
          if (response.status === 200) {
            dispatch(
              ACTIONS.setPlanification({
                ...app.planification,
                bilans: response.data.planification.bilans,
              })
            )
            dispatch(ACTIONS.refresh(false))
            let catList = []
            response.data.planification.bilans.forEach((bilan, i) => {
              catList.push({ catname: bilan.title, show: false })
            })
            setCat(catList)
            setLoading(false)
          }
        })
        .catch(function (error) {
          console.log(error)
          setLoading(false)
        })
    }
  }, [app.planification, dispatch])

  const _changeCat = (o) => {
    let newcat = []
    cat.forEach((c) => {
      if (c.catname === o.catname) newcat.push(o)
      else newcat.push(c)
    })
    setCat(newcat)
  }

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center h-full">
        <Oval color="#48BFAD" height={100} width={100} />
      </div>
    )
  }

  return (
    <div className='w-full bg-white p-6 border-gray-200'>
      <div className='divide-y divide-gray-200 mb-4'>
        <div className='space-y-1'>
          <Subtitle title='Infos' />
          <Title title='Bilans' />

          <div className='py-5 grid gap-4'>
            {cat !== null &&
              app.planification.bilans &&
              app.planification.bilans.map((bilan, index) => {
                if (!bilan) return null
                let isOpen = _.filter(cat, { catname: bilan.title })
                return (
                  <div key={bilan.title || index} className='mt-4'>
                    <div
                      onClick={() =>
                        _changeCat({
                          catname: bilan.title,
                          show: !isOpen[0]?.show,
                        })
                      }
                      className='border-b flex justify-between cursor-pointer'
                    >
                      <h3>{bilan.title}</h3>
                      {isOpen[0]?.show ? (
                        <BsToggleOn size={25} />
                      ) : (
                        <BsToggleOff size={25} />
                      )}
                    </div>

                    <Transition
                      show={isOpen[0]?.show || false}
                      enter="transition-opacity duration-75"
                      enterFrom="opacity-0"
                      enterTo="opacity-100"
                      leave="transition-opacity duration-150"
                      leaveFrom="opacity-100"
                      leaveTo="opacity-0"
                    >
                      {bilan.files &&
                        bilan.files.map((file) => {
                          return (
                            <div key={file.id} className='flex rounded-md shadow mb-2'>
                              <a
                                target='_blank'
                                rel='noreferrer'
                                href={`${process.env.REACT_APP_APOLLO_URL || 'https://extranet.biobreizh.org'}/g/export.php?file=${file.id}`}
                                className='flex-1 items-center justify-center px-5 py-3 border border-transparent text-white font-medium rounded-md text-white bg-base hover:bg-base-light'
                              >
                                {file.name}
                              </a>
                            </div>
                          )
                        })}
                    </Transition>
                  </div>
                )
              })}
          </div>
        </div>
      </div>
    </div>
  )
}
